export enum StorageValues {
  HiddenMuteModalEvents = 'hiddenMuteModalEvents',
  DismissMessages = 'dismissMessages',
  Assistant = 'assistant',
  ExtraLaunchArgs = 'extraLaunchArgs',
  TransitionLoadingScreen = 'transitionLoadingScreen',
}

export enum StorageTypes {
  Local = 'local',
  Session = 'session',
}
